import styled from '@emotion/styled';
import { space } from 'styled-system';
import { Box } from '../Flexbox';

export const HeroBody = styled(Box)(
  {
    marginTop: 'auto',
    marginBottom: 'auto',
  },
  space
);
